import { API } from "../../constAPI";// Ensure you import or define your API base URL correctly

export const getAllSurveyHeaders = async (token) => {
    return fetch(`${API}/api/admin/survey-headers`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    }).then(response => response.json())
      .catch(error => console.error('Error fetching survey headers:', error));
};

export const getSurveyHeader = async (id, token) => {
    return fetch(`${API}/api/admin/survey-headers/${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    }).then(response => response.json())
      .catch(error => console.error('Error fetching survey header:', error));
};

export const addSurveyHeader = async (headerDetails, token) => {
    return fetch(`${API}/api/admin/survey-headers`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(headerDetails)
    }).then(response => response.json())
      .catch(error => console.error('Error adding survey header:', error));
};

export const updateSurveyHeader = async (id, headerDetails, token) => {
    return fetch(`${API}/api/admin/survey-headers/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(headerDetails)
    }).then(response => response.json())
      .catch(error => console.error('Error updating survey header:', error));
};

export const deleteSurveyHeader = async (id, token) => {
    return fetch(`${API}/api/admin/survey-headers/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (response.ok) return { success: true };
        return response.json();
    }).catch(error => console.error('Error deleting survey header:', error));
};
